<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-start pe-5">
                    <h3 class="fw-bold my-4">Enterprise Services in AI, Data, and Emerging Technologies</h3>
                    <!-- <h5 class="fw-bold my-4">خدمات متنوع و تخصصی بازار ارزهای دیجیتال</h5>
                    <h6 class="my-4">با استفاده از بروز ترین خدمات حداکثر بازدهی را تجربه کنید</h6> -->
                    <button class="btn-blue mt-5">Free Registration</button>
                </div>
                <div class="col-md-5 text-end">
                    <img src="../../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">Corporate Services</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        In today’s competitive world, organizations need to leverage modern technologies to maintain a competitive edge and enhance productivity. At our company, relying on advanced technical and engineering expertise, we offer innovative solutions in artificial intelligence, data engineering, blockchain, the Internet of Things, and other transformative technologies. Our corporate services help you optimize your workflows, make smarter decisions, and steer your business toward a digital future.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-start">
                        <h4 class="fw-bold">Organizations’ Needs and Existing Challenges</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>Inefficient Utilization of Data:</strong>
                                    Many organizations possess valuable data but are unable to leverage it for strategic decision-making.
                                </li>
                                <li class="mt-3">
                                    <strong>Challenges in Implementing Modern Technologies:</strong>
                                    Entering fields like artificial intelligence and blockchain without proper solutions can create numerous complexities.
                                </li>
                                <li class="mt-3">
                                    <strong>Rising Costs and Reduced Efficiency:</strong>
                                    Organizations relying on traditional methods often face higher expenses and lower productivity.
                                </li>
                                <li class="mt-3">
                                    <strong>Need for Intelligent Resource and Process Management:</strong>
                                    Organizations seek ways to optimize resource management, reduce costs, and improve efficiency.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">Our Solutions for Organizations</h3>
                <h6>We provide comprehensive services for organizations, including the following:</h6>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold mt-5">Deployment and Implementation of Artificial Intelligence in Organizations</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analyzing and processing organizational data for better decision-making</li>
                                <li>Implementing machine learning models to forecast business trends</li>
                                <li>Smartening internal processes and increasing organizational automation</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Data Engineering and Organizational Data Management</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Designing and implementing scalable data infrastructures</li>
                                <li>Processing and analyzing big data</li>
                                <li>Organizational data management solutions to enhance security and accessibility</li>
                            </ul>    
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Blockchain Solutions for Organizational Security and Transparency</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Implementing smart contracts to automate processes</li>
                                <li>Enhancing data security and reducing risks of fraud and data manipulation</li>
                                <li>Creating decentralized systems for data management</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Internet of Things (IoT) for Optimizing Organizational Operations</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Connecting and integrating organizational equipment to boost productivity</li>
                                <li>Intelligent monitoring of assets and business processes</li>
                                <li>Analyzing sensor data to improve system performance</li>
                            </ul>  
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Intelligent Solutions for Human Resource Management and Office Automation</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Employee performance analysis systems and behavior prediction</li>
                                <li>Implementing automation tools to enhance organizational productivity</li>
                                <li>Utilizing machine learning algorithms to optimize recruitment and employee training</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img5.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Digital Transformation Consulting and Strategy</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Analysis of the Organization’s Current Status and Providing a Digitalization Roadmap</li>
                                <li>Developing Technology Strategies to Enhance Productivity and Profitability</li>
                                <li>Training and Empowering Managers and Employees in Emerging Technologies</li>
                            </ul>  
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Cybersecurity Management and Data Protection</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Security assessment of organizational infrastructures and mitigation of cyber threats</li>
                                <li>Implementing encryption solutions and access control to protect data</li>
                                <li>Developing Security Protocols to Counter Cyber Attacks</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img7.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-5 my-auto text-start">
                        <img src="../../../assets/services-img/img8.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Enterprise Software Development and System Customization</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>Design and implementation of enterprise software based on business needs</li>
                                <li>Optimization and customization of Enterprise Resource Planning (ERP) systems</li>
                                <li>Integration of legacy software with modern technologies</li>
                            </ul>  
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px;">
            <div class="container my-5 py-3">
                <h2 class="my-5 text-start">Outcomes and Value Creation for Organizations</h2>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/fast.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Enhancing Decision-Making Speed and Accuracy </strong>through the use of Artificial Intelligence and Data Analytics
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Product.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Reducing Operational Costs and Increasing Efficiency </strong>through the Implementation of Smart Technologies 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Enhancing Information Security and Process Transparency </strong>through the Use of Blockchain and Data Management 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Improving Information Security and Process Transparency </strong>through the Adoption of Blockchain and Data Management 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Optimizing Organizational Processes </strong>through Automation and Reduced Human Intervention 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Organizing.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Enhancing Management and Monitoring of Organizational Operations </strong>using the Internet of Things (IoT) and Real-Time Data 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../../assets/services-img/Online report.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>Driving Innovation and Digital Transformation </strong>through Expert Consulting and Implementation of Cutting-Edge Technologies 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>FAQ</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>How can I utilize your enterprise services?</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        You can contact our consulting team to discuss your needs. Our experts will then conduct a thorough analysis and provide the most suitable solutions.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>Is your service suitable for small organizations as well?</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, we tailor our solutions to fit the size and needs of every organization, whether large enterprises or small and medium-sized businesses.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>How is the security of organizational data ensured?</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        How is the security of organizational data ensured?
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>Are your services customizable?</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, we design and implement our solutions tailored to the specific needs of each organization to deliver maximum value to our clients.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>Does your team provide necessary training to the organization’s staff?</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        Yes, in addition to implementing solutions, we provide comprehensive training for the organization’s staff to ensure they can effectively utilize the new technologies.
                        <br>
                        As a solution-driven company, we help organizations take effective steps toward development and digital transformation by leveraging modern technologies. For consultation and more information, please contact us.
                    </div>
                  </div>
                </div>

                <!-- 6: coll6 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll6",  id="coll6"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll6" aria-expanded="false" aria-controls="coll6">
                      <h6>Are the predictions at Nabaco explainable?</h6>
                    </button>
                  </h2>
                  <div id="coll6" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                     We believe that the explainability of machine learning models is as important as their performance in many business applications, due to reasons such as trust, regulations, technical, and ethical considerations. Our AI platform supports the SHAP (SHapley Additive exPlanations) technique, which breaks down each prediction into the contribution of individual input variables. The contribution of each input variable (positive or negative) can be calculated, and the sum of these contributions provides the model’s prediction. This approach allows us to explain a prediction using only a small number of feature groups and leverages the additive property of SHAP values.
                    </div>
                  </div>
                </div>

                <!-- 7: coll7 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll7",  id="coll7"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll7" aria-expanded="false" aria-controls="coll7">
                      <h6>Explainable AI and Feature Selection</h6>
                    </button>
                  </h2>
                  <div id="coll7" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      Nabaco’s technology utilizes a clustering-based MDA (Mean Decrease Accuracy) approach for ranking and selecting feature importance. This method has been chosen because it provides explainable and highly stable results for our users.
                    </div>
                  </div>
                </div>

                <!-- 8: coll8 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll8",  id="coll8"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll8" aria-expanded="false" aria-controls="coll8">
                      <h6>Conditional Portfolio Optimization</h6>
                    </button>
                  </h2>
                  <div id="coll8" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      Nabaco’s technology employs a clustering-based MDA (Mean Decrease Accuracy) method for ranking and selecting feature importance. This approach has been chosen for its ability to deliver explainable and highly stable results to our users.
                    </div>
                  </div>
                </div>

                <!-- 9: coll9 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll9",  id="coll9"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll9" aria-expanded="false" aria-controls="coll9">
                      <h6>Risk Management through Prescriptive AI</h6>
                    </button>
                  </h2>
                  <div id="coll9" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      Nabaco's software leverages machine learning models to assess the probability of profit for trades, as well as to support capital allocation and risk management. This quantitative-fundamental approach helps discretionary or fundamental investment managers translate their strategies and insights into a systematic and data-driven framework—without the need to disclose their underlying strategy to the advisor.
                    </div>
                  </div>
                </div>

              </div>
            </div>

        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
*{
  direction: ltr;
}
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  right: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  right: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>